import {IProduct} from 'modules/product-card/models/ProductResponse';
import {useMemo} from 'react';

export const useProductDiscount = (product?: Partial<IProduct> | null) => {
    return useMemo(() => {
        if (!product) {
            return undefined;
        }

        const {discount, specPrice} = product.price ?? {};
        const {price: discountPrice = 0, discountValue = 0} = discount ?? {};

        if (null === specPrice && 0 < discountPrice && 0 < discountValue) {
            return discountValue;
        }

        return undefined;
    }, [product]);
};
